import { render, staticRenderFns } from "./TeamSection.vue?vue&type=template&id=1d39ee5d&scoped=true&"
import script from "./TeamSection.vue?vue&type=script&lang=js&"
export * from "./TeamSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamSection.vue?vue&type=style&index=0&id=1d39ee5d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39ee5d",
  null
  
)

export default component.exports